import { render, staticRenderFns } from "./CredencialesAportesEnLinea.vue?vue&type=template&id=4d70d5cb&scoped=true"
import script from "./CredencialesAportesEnLinea.vue?vue&type=script&lang=js"
export * from "./CredencialesAportesEnLinea.vue?vue&type=script&lang=js"
import style0 from "./CredencialesAportesEnLinea.vue?vue&type=style&index=0&id=4d70d5cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d70d5cb",
  null
  
)

export default component.exports